// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"pX-z","sponsoredTooltipWrapper":"qX-z","sponsoredTooltip":"rX-z","newCard":"sX-z"};